// Estética tipo "bar épico": fondo crema claro, bandas oscuras carbón y acento
// verde tomado del logo real (#004143). Tipografía: sans bold condensada para
// títulos + serif display de contraste. Los nombres de tokens se conservan de
// versiones anteriores: `pink`/`gold` mapean al verde de acento (antes
// amarillo), `purple` al carbón oscuro. `gold`/`pinkSoft` usan una variante
// vívida del verde del logo para mantener el mismo contraste con texto oscuro
// que tenía el amarillo original; `brandGreen` es el tono exacto del logo.
const theme = {
  colors: {
    bg: '#f4f3ee',
    bgDarker: '#1d1b17',
    surface: '#ffffff',
    surfaceStrong: '#faf9f5',
    border: 'rgba(29, 27, 23, 0.14)',
    pink: '#2dd4bf',
    pinkSoft: '#7ee8d1',
    purple: '#1d1b17',
    purpleDeep: '#0f0e0b',
    gold: '#2dd4bf',
    brandGreen: '#004143',
    red: '#c0392b',
    green: '#1e8e5a',
    text: '#23211c',
    textMuted: '#6f6a5e',
    textFaint: '#9b9689'
  },
  gradients: {
    primary: 'linear-gradient(135deg, #3fe0cb 0%, #17b8a2 100%)',
    primaryHover: 'linear-gradient(135deg, #7ee8d1 0%, #2dd4bf 100%)',
    surface: 'linear-gradient(160deg, #ffffff 0%, #faf9f5 100%)'
  },
  glow: {
    pink: '0 4px 16px rgba(45, 212, 191, 0.35)',
    purple: '0 4px 16px rgba(29, 27, 23, 0.25)',
    gold: '0 4px 16px rgba(45, 212, 191, 0.35)',
    soft: '0 6px 24px rgba(29, 27, 23, 0.08)'
  },
  fonts: {
    display: "'Playfair Display', serif",
    heading: "'Montserrat', sans-serif",
    body: "'Lato', sans-serif"
  },
  radii: {
    sm: '2px',
    md: '4px',
    lg: '6px',
    pill: '999px'
  },
  breakpoints: {
    sm: '480px',
    md: '768px',
    lg: '1024px',
    xl: '1280px'
  },
  zIndex: {
    header: 50,
    modal: 100,
    toast: 110
  }
};

export default theme;
